import {Response} from 'express';
import {ChangeDetectionStrategy, Component, Inject, inject, OnInit, Optional, PLATFORM_ID} from '@angular/core';
import {CommonModule, isPlatformServer} from "@angular/common";

import {RESPONSE} from './server.token';
import {RouterLink} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {APP_ROUTES} from "../../../constants/routes";
import {NAVS} from "../../../constants/navs";

@Component({
    selector: 'app-not-found',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent implements OnInit {

    platformId = inject(PLATFORM_ID);

    constructor(
        @Optional() @Inject(RESPONSE) private response: Response,
        private title: Title
    ) {
        // Only executes server-side
        if (isPlatformServer(this.platformId)) {
            this.response?.status(404);
        }
    }

    ngOnInit() {
        this.title.setTitle('MotorDesk - страница не найдена');
    }


    protected readonly APP_ROUTES = APP_ROUTES;
    protected readonly NAVS = NAVS;
}
